import { render, staticRenderFns } from "./portSelectNew.vue?vue&type=template&id=715ab201&scoped=true"
import script from "./portSelectNew.vue?vue&type=script&lang=js"
export * from "./portSelectNew.vue?vue&type=script&lang=js"
import style0 from "./portSelectNew.vue?vue&type=style&index=0&id=715ab201&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ab201",
  null
  
)

export default component.exports